export default {
      id: "icon-cart-usage",
      viewBox: "0 0 26 21",
      url: __webpack_public_path__ + "icons.svg#icon-cart",
      toString: function () {
        return this.url;
      }
    }